import * as React from "react";
import {cx} from "emotion";

import "./print-service.scss";

import {cs}            from "@Common/react/chain-services";
import {Link}          from "@Common/react/cst2";
import {fragments}     from "@Common/react/fragments";
import {TimeoutAction} from "@Common/react/timeout-action";
import {UseState}      from "@Common/react/use-state";

import {StyleTag} from "./style-tag";

/* PrintService component must be initialized at the beginning of the page */
export const PrintService = ({next}:{
    next : Link<JSX.Element, {
        print : (content:React.ReactNode) => void,
    }>,
}) => cs(
    ["state", (_, next) => UseState({next})],
    ["styleTag", (_, next) => StyleTag({next})],
    ({state, styleTag}) => (
        <div className="print-service print-service-38e">
            <div className={cx({"no-print": state.value})}>
                {next({
                    print: async (content) => {
                        state.onChange({content});
                    },
                })}
            </div>

            {state.value && fragments(
                <div className="print">
                    {state.value.content}
                </div>,
                styleTag.render({
                    content: [
                        "@media print {",
                        "  @page { margin: 0; }",
                        // "  body { margin: 1.6cm; }",
                        "  body {",
                        "    -webkit-print-color-adjust: exact !important;",
                        "  }",
                        "  ._hj_feedback_container {",
                        "    display: none;",
                        "  }",
                        "}"
                    ].join(""),
                }),
                TimeoutAction({
                    delay: 100,
                    action: () => {
                        window.print();
                    },
                }),
                TimeoutAction({
                    delay: 2000,
                    action: () => state.onChange(null),
                }),
            )}
        </div>
    ),
);
